// src/pages/ProductsPage.tsx — Site officiel Vanessa
import { Link } from 'react-router-dom';
import { PageHeader, Section, Grid, CtaBand } from '@/components/site/blocks';
import { PRODUCTS } from '@/content/products';
import { APP_OPEN_URL } from '@/config/site';

export default function ProductsPage() {
    return (
        <>
            <PageHeader
                eyebrow="Produits"
                title="Tout ce que Vanessa fait pour vous"
                intro="Une conversation, un fil d’histoires, une carte de bons plans : un seul compte pour tout."
            />
            <Section>
                <Grid cols={3}>
                    {PRODUCTS.map((p) => (
                        <Link
                            key={p.slug}
                            to={`/produits/${p.slug}`}
                            className="group flex h-full flex-col rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
                        >
                            <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-brand-tint text-ochre">
                                <p.icon className="h-6 w-6" aria-hidden="true" />
                            </span>
                            <h2 className="font-display text-xl font-semibold text-ink">{p.name}</h2>
                            {p.status && (
                                <p className="mt-1 text-sm font-medium text-ochre">{p.status}</p>
                            )}
                            <p className="mt-2 flex-1 text-base leading-relaxed text-gray-700">{p.tagline}</p>
                            <span className="mt-4 font-semibold text-ochre group-hover:underline">
                                En savoir plus <span aria-hidden="true">→</span>
                            </span>
                        </Link>
                    ))}
                </Grid>
            </Section>
            <CtaBand
                title="Essayez par vous-même"
                text="Créez un compte et commencez la conversation."
                primary={{ label: 'Ouvrir l’application', href: APP_OPEN_URL }}
                secondary={{ label: 'Guide d’utilisation', to: '/guide' }}
            />
        </>
    );
}
